import { makeStyles } from '@material-ui/core/styles';
export default makeStyles((theme) => ({
  card: {
    '&&': {
      backgroundColor: theme.colorPalette.green_100,
      color: theme.colorPalette.white,
      border: 0,
      padding: theme.spacing(4.5),
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3)
    },
    '& p, & h2, & span': { color: 'inherit' }
  },
  header: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: theme.spacing(2) },
  heading: { '&&': { margin: 0, fontSize: 16, fontWeight: 600, color: 'inherit' } },
  id: { fontSize: 12, overflowWrap: 'anywhere' },
  row: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: theme.spacing(3),
    borderTop: `1px solid ${theme.colorPalette.white_op_30}`,
    paddingTop: theme.spacing(3)
  },
  amount: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: theme.spacing(1),
    '& strong': { fontSize: 24, lineHeight: '30px' },
    '& span': { fontSize: 12 }
  },
  status: { opacity: 0.85 },
  details: {
    padding: theme.spacing(3, 4),
    border: `1px solid ${theme.colors.card_divider}`,
    borderRadius: theme.sizes.roundCorners,
    '& > summary': { cursor: 'pointer', fontSize: 14 },
    '&[open] > summary': { marginBottom: theme.spacing(3) }
  }
}));
